module.exports = __webpack_public_path__ + "img/retail.5e60bc34.png";